import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC } from 'react';

type LabelWithIconProps = {
  icon: IconDefinition;
  label: string;
  color?: string;
};

export const LabelWithIcon: FC<LabelWithIconProps> = ({
  icon,
  label,
  color,
}) => {
  return (
    <span>
      <FontAwesomeIcon icon={icon} color={color} /> {label}
    </span>
  );
};
